<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">撥入對象-{{segmentName}}</h3>
        </div>
        <div class="modal-body">
            <section class="search pb-0 mb-4">
                <div class="row">
                    <div class="col-12">
                        轄下內單位資訊:
                    </div>
                </div>
            </section>

            <table class="segment-table table datatable table-striped table-bordered">
                <thead>
                    <tr>
                        <th width="60px"></th>
                        <th width="80px">單位名稱</th>
                        <th width="110px">人均服務件數</th>
                        <th width="110px">人均要保人數</th>
                        <th width="65px">新人數</th>
                        <th width="100px">撥件未達<br>門檻新人數</th>                       
                        <th width="80px">未訪要保人數</th>
                        <th width="*">本年度6個月<br>內實質接觸率</th>
                    </tr>
                </thead>
                <tbody v-if="true">
                    <tr v-for="(d, did) in unitsList" :key="`td-${did}`">
                        <td width="60px">
                            <div class="mr-0 radio radio-inline">
                                <input type="radio" name="td-item" :id="`radio-${did}`" :value="d" v-model="selection">
                                <label :for="`radio-${did}`"></label>
                            </div>
                        </td>
                        <td width="80px">{{d.div_short_name}}</td>
                        <td width="110px">{{d.avg_service_per_person}}</td>
                        <td width="110px">{{d.avg_apc_per_person}}</td>
                        <td width="65px">{{d.new_agent_count || 0}}</td>
                        <td width="100px">{{d.count_tmp7 || 0}}</td>                                              
                        <td width="80px">{{d.n_remain || 0}}</td>
                        <td width="*">{{d.rate_6 || 0}}%</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                    <td colspan="8" class="empty">
                        <h3 class="text-center py-5">無客戶資料</h3>
                    </td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    </tr>
                </tbody>
            </table>
            
            <div class="row">
                <div class="col-12 text-right">
                    <a @click="$emit('close')" class="btn btn-default">取消</a>
                    <a @click="$emit('submit', selection)" class="btn btn-primary">加入</a>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'DialInPersonModal',
    props: {
        open: {
            type: Boolean,
            default: false
        },
        segmentUnitsList: {
            type: Array,
            default: () => {
                return []
            },
        },
        segmentName:{
            type: String,
            default: () => {
                ''
            },   
        }             
    },
    watch: {
        open: function () {
            this.updateList()
        },
    },
    data () {
        return {
            remoteDataMsg: "資料讀取中，請稍候...",
            keyowrd: '',
            selection: [],
            unitsList: [],
        }
    },
    methods: {
        doSearch () {
            // 難字 update
            this.agntList = []
            setTimeout(() => {
                this.unitsList = this.segmentUnitsList.filter(item => {
                    return item.div_short_name.includes(this.keyowrd) || item.clcno.includes(this.keyowrd)
                })
                this.registerHanlink()  
            }, 100);
        },
        updateList () {
            this.selection = []
            this.keyowrd = ''

            // 難字 update
            this.unitsList = []
            setTimeout(() => {
                this.unitsList = [...this.segmentUnitsList]
                this.registerHanlink()  
            }, 100);
        },
    }
}
</script>

<style lang="scss" scoped>

.segment-table thead tr,.segment-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.segment-table tbody tr {
  height: 54px;
}

.segment-table tbody {
  display: block;
  height: 300px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    width: 17px; 
    border: 0;
    box-shadow: none;
  }
  
  &::-webkit-scrollbar-track
  {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.segment-table tbody tr > td {
    font-size: 15px;
}

.segment-table th {
    font-size: 14px;
}

</style>